const isObject = (item: unknown) => {
  return item && typeof item === "object" && !Array.isArray(item);
};

const deepMerge = (
  target: Record<string, any>,
  ...sources: Record<string, any>[]
): Record<string, any> => {
  if (!isObject(target)) throw new Error("Target is not an object");

  if (!sources.length) return target;
  const source = sources.shift();

  if ([target, source].every(isObject)) {
    for (const key in source) {
      if (isObject(source[key])) {
        if (!target[key]) Object.assign(target, { [key]: {} });
        deepMerge(target[key], source[key]);
      } else {
        Object.assign(target, { [key]: source[key] });
      }
    }
  }

  return deepMerge(target, ...sources);
};

export default deepMerge;
